<template>
    <div class="row embebido">
        <embed v-for="contenidoDeLaPaginaWeb in seccionDeLaPaginaWeb.ContenidosDeLaPaginaWeb" v-bind:key="contenidoDeLaPaginaWeb.ContenidoDeLaPaginaWebId" v-bind:src="contenidoDeLaPaginaWeb.Vinculo" />
    </div>
</template>

<script>
export default {
    props: {
        seccionDeLaPaginaWeb: Object
    }
}
</script>

<style scoped>
  .embebido {
    height: 100%;
  }

  .embebido embed{
    width: 100%;
    height: calc(100vh - 26vh);
  }
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaInformativa/Formatos/Embebido.vue